import { truthy } from '@dmp/shared/helpers';
import type { AnswerState, StoreState } from '../../state-types';

/** Get all Answers for a Card by cardId */
export const getCardAnswers =
    (cardId: string) =>
    (state: StoreState): AnswerState[] =>
        state.actions
            .getCardAnswerIds(cardId)
            .map((answerId) => state.answers[answerId])
            .filter(truthy);
